import React, { useEffect, useState, createElement } from 'react';
import { CheckIcon, BookOpenIcon, MailIcon, SparklesIcon, ShieldCheckIcon } from 'lucide-react';
export function App() {
  const [showPopup, setShowPopup] = useState(false);
  const [popupData, setPopupData] = useState({
    name: '',
    city: ''
  });
  const argentineCities = ['Buenos Aires', 'Córdoba', 'Rosario', 'Mendoza', 'La Plata', 'San Miguel de Tucumán', 'Mar del Plata', 'Salta', 'Santa Fe', 'San Juan', 'Resistencia', 'Neuquén', 'Posadas', 'Bahía Blanca'];
  const argentineNames = ['María González', 'Laura Fernández', 'Sofía Rodríguez', 'Camila López', 'Lucía Martínez', 'Valentina Pérez', 'Martina García', 'Ana Silva', 'Carolina Romero', 'Gabriela Torres', 'Patricia Díaz', 'Natalia Castro', 'Diego Morales', 'Javier Ruiz', 'Sebastián Álvarez', 'Matías Benítez'];
  useEffect(() => {
    const interval = setInterval(() => {
      const randomName = argentineNames[Math.floor(Math.random() * argentineNames.length)];
      const randomCity = argentineCities[Math.floor(Math.random() * argentineCities.length)];
      setPopupData({
        name: randomName,
        city: randomCity
      });
      setShowPopup(true);
      setTimeout(() => setShowPopup(false), 4000);
    }, 8000);
    return () => clearInterval(interval);
  }, []);
  const scrollToPurchase = () => {
    const purchaseSection = document.getElementById('purchase-section');
    if (purchaseSection) {
      purchaseSection.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  useEffect(() => {
    const script = document.createElement('script');
    script.innerHTML = `
      !function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window, document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', '26257470350562748');
      fbq('track', 'PageView');
    `;
    document.head.appendChild(script);
    const noscript = document.createElement('noscript');
    noscript.innerHTML = `<img height="1" width="1" style="display:none" src="https://www.facebook.com/tr?id=26257470350562748&ev=PageView&noscript=1" />`;
    document.body.appendChild(noscript);
  }, []);
  return <div className="w-full min-h-screen bg-gradient-to-b from-slate-50 to-white" data-id="element-0">
      {/* Popup Notification */}
      {showPopup && <div className="fixed bottom-6 left-6 z-50 bg-white border border-green-200 rounded-lg shadow-xl p-4 max-w-sm animate-slide-in" data-id="element-1">
          <div className="flex items-start gap-3" data-id="element-2">
            <div className="flex-shrink-0 w-10 h-10 bg-green-100 rounded-full flex items-center justify-center" data-id="element-3">
              <CheckIcon className="w-5 h-5 text-green-600" data-id="element-4" />
            </div>
            <div className="flex-1" data-id="element-5">
              <p className="text-sm font-semibold text-gray-900" data-id="element-6">
                {popupData.name}
              </p>
              <p className="text-xs text-gray-600" data-id="element-7">de {popupData.city}</p>
              <p className="text-xs text-gray-500 mt-1" data-id="element-8">
                Acaba de comprar el Kit Informes TCC
              </p>
            </div>
          </div>
        </div>}

      {/* Hero Section */}
      <section className="min-h-screen bg-gradient-to-br from-blue-50 via-indigo-50 to-purple-50 flex items-center justify-center px-4 py-4" data-id="element-9">
        <div className="max-w-6xl mx-auto w-full flex flex-col items-center justify-center" data-id="element-10">
          <div className="text-center mb-4 md:mb-6" data-id="element-11">
            <h1 className="text-2xl sm:text-3xl md:text-5xl font-bold text-gray-900 mb-3 md:mb-5 leading-tight" data-id="element-12">
              INTEGRA CHATGPT Y CLAUDE A TUS INFORMES DE TERAPIA COGNITIVO
              CONDUCTUAL
            </h1>
            <p className="text-base sm:text-lg md:text-xl text-gray-700 max-w-3xl mx-auto" data-id="element-13">
              Terminás de atender, tenés notas, ideas e intervenciones claras…
              pero cuando abrís el documento, aparece la hoja en blanco.
            </p>
          </div>

          <div className="flex justify-center mb-4 md:mb-6" data-id="element-14">
            <img src="https://cdn.magicpatterns.com/uploads/vCKpkXMFzc1Mrt6xgLmqB7/Diseno_sin_titulo_(26).png" alt="Kit Informes TCC con IA" className="max-w-[100%] sm:max-w-[80%] md:max-w-[60%] max-h-[60vh] h-auto cursor-pointer hover:scale-105 transition-transform duration-300" onClick={scrollToPurchase} data-id="element-15" />
          </div>

          <div className="text-center" data-id="element-16">
            <button onClick={scrollToPurchase} className="bg-blue-600 hover:bg-blue-700 text-white font-bold text-base md:text-lg px-6 md:px-8 py-3 md:py-4 rounded-lg shadow-lg hover:shadow-xl transition-all duration-300 inline-block" data-id="element-17">
              👉 ACCEDER AL KIT INFORMES TCC CON IA
              <span className="block text-xs md:text-sm mt-1" data-id="element-18">
                $19.900 ARS · Acceso inmediato
              </span>
            </button>
          </div>
        </div>
      </section>

      {/* Product Description Section */}
      <section className="bg-white py-16" data-id="element-19">
        <div className="max-w-5xl mx-auto px-4" data-id="element-20">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4 text-center" data-id="element-21">
            KIT INFORMES TCC CON IA
          </h2>
          <p className="text-lg text-gray-700 mb-8 text-center max-w-3xl mx-auto" data-id="element-22">
            Un sistema práctico de más de 200 prompts para psicólogos/as que
            quieren dejar de redactar informes desde cero y empezar a usar IA
            con estructura, claridad y criterio profesional.
          </p>

          <div className="grid md:grid-cols-2 gap-4 mb-8" data-id="element-23">
            {['Generás informes iniciales', 'Generás informes de evolución', 'Generás informes de seguimiento', 'Generás informes de derivación', 'Generás informes de cierre', 'Armás conceptualizaciones de caso TCC', 'Convertís notas de sesión en borradores editables', 'Adaptás el tono para pacientes, colegas o instituciones'].map((item, index) => <div key={index} className="flex items-start gap-3 bg-green-50 p-4 rounded-lg" data-id="element-24">
                <CheckIcon className="w-6 h-6 text-green-600 flex-shrink-0 mt-0.5" data-id="element-25" />
                <span className="text-gray-800 font-medium" data-id="element-26">{item}</span>
              </div>)}
          </div>

          <p className="text-2xl font-bold text-center text-gray-900" data-id="element-27">
            Copiás. Pegás. Adaptás. Revisás. Entregás.
          </p>
        </div>
      </section>

      {/* Pain Points Section */}
      <section className="bg-gradient-to-br from-orange-50 to-red-50 py-16" data-id="element-28">
        <div className="max-w-4xl mx-auto px-4" data-id="element-29">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6 text-center" data-id="element-30">
            🔥 NO ES QUE NO SEPAS HACER INFORMES. ES QUE LOS ESTÁS EMPEZANDO
            DESDE CERO.
          </h2>
          <p className="text-lg text-gray-700 mb-6 text-center" data-id="element-31">
            Podés tener claridad clínica durante la sesión… y aun así trabarte
            cuando llega el momento de escribir.
          </p>
          <p className="text-lg text-gray-700 mb-6 text-center font-semibold" data-id="element-32">
            Porque redactar informes tiene fugas de tiempo:
          </p>

          <div className="space-y-3 mb-8" data-id="element-33">
            {['notas sueltas difíciles de ordenar', 'informes que se postergan', 'textos que quedan demasiado genéricos', 'dudas sobre cómo sonar profesional', 'ChatGPT o Claude respondiendo cualquier cosa por falta de un buen prompt'].map((item, index) => <div key={index} className="flex items-start gap-3 bg-white p-4 rounded-lg shadow-sm" data-id="element-34">
                <span className="text-red-500 font-bold flex-shrink-0" data-id="element-35">✗</span>
                <span className="text-gray-800" data-id="element-36">{item}</span>
              </div>)}
          </div>

          <p className="text-xl font-bold text-center text-gray-900 mb-8" data-id="element-37">
            👉 Sin un sistema, cada informe vuelve a empezar desde cero.
          </p>

          <div className="text-center" data-id="element-38">
            <button onClick={scrollToPurchase} className="bg-red-600 hover:bg-red-700 text-white font-bold text-lg px-8 py-4 rounded-lg shadow-lg hover:shadow-xl transition-all duration-300" data-id="element-39">
              QUIERO DEJAR DE REDACTAR DESDE CERO
            </button>
          </div>
        </div>
      </section>

      {/* Bonuses Section */}
      <section className="bg-white py-16" data-id="element-40">
        <div className="max-w-5xl mx-auto px-4" data-id="element-41">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4 text-center" data-id="element-42">
            🎁 BONUS GRATIS HOY
          </h2>
          <p className="text-xl text-center text-gray-700 mb-12 font-semibold" data-id="element-43">
            HOY TAMBIÉN TE LLEVÁS ESTAS HERRAMIENTAS PRÁCTICAS
          </p>

          <div className="grid md:grid-cols-2 gap-8 mb-8" data-id="element-44">
            {/* Bonus 1 */}
            <div className="relative bg-gradient-to-br from-blue-50 to-indigo-50 border-2 border-blue-200 rounded-xl p-6 shadow-lg" data-id="element-45">
              <div className="absolute -top-4 -right-4 bg-yellow-400 text-yellow-900 font-bold text-sm px-4 py-2 rounded-full shadow-md flex items-center gap-1" data-id="element-46">
                <SparklesIcon className="w-4 h-4" data-id="element-47" />
                GRATIS HOY
              </div>
              <div className="flex items-center gap-4 mb-4" data-id="element-48">
                <div className="w-14 h-14 bg-blue-600 rounded-lg flex items-center justify-center flex-shrink-0" data-id="element-49">
                  <BookOpenIcon className="w-8 h-8 text-white" data-id="element-50" />
                </div>
                <h3 className="text-xl font-bold text-gray-900" data-id="element-51">
                  Bonus 1 — Guía de Inicio Rápido con IA
                </h3>
              </div>
              <p className="text-gray-700 mb-3" data-id="element-52">
                Para psicólogos/as que quieren empezar a usar Claude o ChatGPT
                sin perder tiempo probando al azar.
              </p>
              <p className="text-gray-700" data-id="element-53">
                Aprendé cómo configurar la IA, qué escribir, cómo cargar
                contexto y cómo obtener respuestas más útiles desde el primer
                intento.
              </p>
            </div>

            {/* Bonus 2 */}
            <div className="relative bg-gradient-to-br from-purple-50 to-pink-50 border-2 border-purple-200 rounded-xl p-6 shadow-lg" data-id="element-54">
              <div className="absolute -top-4 -right-4 bg-yellow-400 text-yellow-900 font-bold text-sm px-4 py-2 rounded-full shadow-md flex items-center gap-1" data-id="element-55">
                <SparklesIcon className="w-4 h-4" data-id="element-56" />
                GRATIS HOY
              </div>
              <div className="flex items-center gap-4 mb-4" data-id="element-57">
                <div className="w-14 h-14 bg-purple-600 rounded-lg flex items-center justify-center flex-shrink-0" data-id="element-58">
                  <MailIcon className="w-8 h-8 text-white" data-id="element-59" />
                </div>
                <h3 className="text-xl font-bold text-gray-900" data-id="element-60">
                  Bonus 2 — Prompts para Correos y Derivaciones
                </h3>
              </div>
              <p className="text-gray-700 mb-3" data-id="element-61">
                Prompts listos para redactar comunicaciones profesionales con
                colegas, instituciones, derivadores, pacientes u obras sociales.
              </p>
              <p className="text-gray-700" data-id="element-62">
                Te ayuda a escribir mensajes claros, formales y profesionales
                sin quedarte pensando cómo empezar.
              </p>
            </div>
          </div>

          <p className="text-2xl font-bold text-center text-green-700" data-id="element-63">
            👉 TODO INCLUIDO SIN COSTO ADICIONAL
          </p>
        </div>
      </section>

      {/* Offer / Purchase Section */}
      <section id="purchase-section" className="min-h-screen bg-gradient-to-br from-blue-900 to-indigo-900 flex items-center justify-center py-6 px-4" data-id="element-64">
        <div className="max-w-4xl mx-auto w-full" data-id="element-65">
          <h2 className="text-xl md:text-3xl font-bold text-white mb-1 md:mb-2 text-center" data-id="element-66">
            💰 OFERTA
          </h2>
          <p className="text-sm md:text-lg text-blue-100 mb-3 md:mb-6 text-center font-semibold" data-id="element-67">
            TODO LO QUE NECESITÁS PARA PASAR DE LA SESIÓN AL INFORME TCC EN
            MINUTOS
          </p>

          <div className="bg-white rounded-2xl shadow-2xl p-4 md:p-8" data-id="element-68">
            <h3 className="text-xl md:text-3xl font-bold text-gray-900 mb-3 md:mb-5 text-center" data-id="element-69">
              KIT INFORMES TCC CON IA
            </h3>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-4 gap-y-2 mb-4 md:mb-5" data-id="element-70">
              {['Más de 200 prompts listos para usar', 'Prompts para informes TCC', 'Prompts para evolución clínica', 'Prompts para seguimiento', 'Prompts para derivación', 'Prompts para cierre', 'Prompts para conceptualización de caso', 'Prompts para adaptar tono y destinatario', 'Bonus 1: Guía de inicio rápido con IA', 'Bonus 2: Prompts para correos y derivaciones'].map((item, index) => <div key={index} className="flex items-start gap-2" data-id="element-71">
                  <CheckIcon className="w-5 h-5 md:w-6 md:h-6 text-green-600 flex-shrink-0 mt-0.5" data-id="element-72" />
                  <span className="text-gray-800 text-base md:text-lg font-medium" data-id="element-73">
                    {item}
                  </span>
                </div>)}
            </div>

            <div className="border-t border-gray-200 pt-3 md:pt-4 mb-3 md:mb-4" data-id="element-74">
              <p className="text-sm text-gray-600 mb-1 text-center" data-id="element-75">PRECIO:</p>
              <div className="text-center mb-1" data-id="element-76">
                <span className="text-xl md:text-3xl text-gray-400 line-through mr-3" data-id="element-77">
                  $49.990
                </span>
                <span className="text-4xl md:text-6xl font-bold text-green-600" data-id="element-78">
                  $19.900 ARS
                </span>
              </div>
              <p className="text-center text-gray-600 text-sm" data-id="element-79">
                Pago único · Sin suscripciones
              </p>
            </div>

            <div className="text-center" data-id="element-80">
              <a href="https://checkout.sectordigital.online/cart/44087008493611:1" className="bg-green-600 hover:bg-green-700 text-white font-bold text-lg md:text-2xl px-8 md:px-12 py-3 md:py-4 rounded-lg shadow-xl hover:shadow-2xl transition-all duration-300 inline-block" data-id="element-81">
                👉 SÍ, QUIERO EL KIT AHORA
                <span className="block text-sm md:text-base mt-1" data-id="element-82">
                  Click aquí para acceder
                </span>
              </a>
            </div>

            <div className="mt-3 md:mt-4 flex flex-wrap justify-center items-center gap-x-4 gap-y-1 text-center" data-id="element-83">
              <div className="flex items-center gap-1.5 text-gray-600" data-id="element-84">
                <ShieldCheckIcon className="w-5 h-5 text-green-600" data-id="element-85" />
                <span className="text-sm" data-id="element-86">Pago 100% seguro</span>
              </div>
              <div className="flex items-center gap-1.5 text-gray-600" data-id="element-87">
                <CheckIcon className="w-5 h-5 text-green-600" data-id="element-88" />
                <span className="text-sm" data-id="element-89">Acceso inmediato</span>
              </div>
              <div className="flex items-center gap-1.5 text-gray-600" data-id="element-90">
                <CheckIcon className="w-5 h-5 text-green-600" data-id="element-91" />
                <span className="text-sm" data-id="element-92">Garantía 7 días</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Testimonials Section */}
      <section className="bg-gray-50 py-16" data-id="element-93">
        <div className="max-w-5xl mx-auto px-4" data-id="element-94">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-12 text-center" data-id="element-95">
            Lo que dicen otros psicólogos
          </h2>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-96">
            {[{
            name: 'Dra. María Fernández',
            age: 38,
            city: 'Buenos Aires',
            text: 'Antes tardaba 2 horas en cada informe. Ahora en 20 minutos tengo un borrador profesional listo para revisar. Cambió mi forma de trabajar completamente.'
          }, {
            name: 'Lic. Sebastián Morales',
            age: 42,
            city: 'Córdoba',
            text: 'Los prompts son específicos para TCC, no genéricos. Se nota que fueron pensados por alguien que entiende la práctica clínica. Muy recomendable.'
          }, {
            name: 'Lic. Laura González',
            age: 35,
            city: 'Rosario',
            text: 'Lo mejor es que puedo adaptar el tono según el destinatario. Ya no me trabo pensando cómo empezar cada informe. Vale cada peso.'
          }, {
            name: 'Lic. Diego Álvarez',
            age: 45,
            city: 'Mendoza',
            text: 'Trabajo con obras sociales y necesito informes formales constantemente. Este kit me ahorra horas de trabajo administrativo cada semana.'
          }, {
            name: 'Dra. Carolina Ruiz',
            age: 40,
            city: 'La Plata',
            text: 'La guía de inicio rápido es excelente. En 10 minutos ya estaba usando Claude para mis informes. Simple y efectivo.'
          }].map((testimonial, index) => <div key={index} className="bg-white p-6 rounded-lg shadow-md border border-gray-200" data-id="element-97">
                <div className="flex items-center gap-3 mb-4" data-id="element-98">
                  <div className="w-12 h-12 bg-blue-600 rounded-full flex items-center justify-center text-white font-bold text-lg" data-id="element-99">
                    {testimonial.name.charAt(testimonial.name.indexOf(' ') + 1)}
                  </div>
                  <div data-id="element-100">
                    <p className="font-bold text-gray-900" data-id="element-101">
                      {testimonial.name}
                    </p>
                    <p className="text-sm text-gray-600" data-id="element-102">
                      {testimonial.age} años · {testimonial.city}
                    </p>
                  </div>
                </div>
                <p className="text-gray-700 italic" data-id="element-103">"{testimonial.text}"</p>
              </div>)}
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-900 py-10" data-id="element-104">
        <div className="max-w-4xl mx-auto px-4 text-center space-y-4" data-id="element-105">
          <p className="text-gray-300 text-sm" data-id="element-106">
            © 2026 KIT Informes TCC con IA. Todos los derechos reservados.
          </p>
          <p className="text-gray-400 text-xs max-w-2xl mx-auto leading-relaxed" data-id="element-107">
            Este sitio no es parte del sitio web de Facebook o Meta Inc. Además,
            este sitio NO está respaldado por Facebook de ninguna manera.
          </p>
        </div>
      </footer>
    </div>;
}